import { FC } from "react";

interface CheckboxProps {
  id: string;
  checked?: boolean;
  onChange?: () => void;
  label: string;
  dataTestId?: string;
}

// Fully controlled: `checked` reflects the prop and `onChange` notifies the
// parent. (Previously it kept its own useState seeded once from `checked`,
// which drifted out of sync whenever the parent updated the prop.)
const Checkbox: FC<CheckboxProps> = ({
  id,
  checked = false,
  onChange,
  label,
  dataTestId,
}) => (
  <div className="checkbox">
    <input
      type="checkbox"
      id={id}
      onChange={() => onChange?.()}
      checked={checked}
      data-testid={dataTestId}
    />
    <label htmlFor={id}>{label}</label>
  </div>
);

export default Checkbox;
